import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { DocumentViewer } from './DocumentViewer';
import "./style.css"
import { FileStorage } from '../../core/FileStorage';
import { PdfViewer } from './PdfViewer';


const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

const getFileExtension = (filename) => {
    if (filename) {
        const parts = filename.split(".");
        if (parts.length > 0) {
            return parts.pop()
        }
    }
    return "";
}

function getDefaultViewer(filename) {
    const extension = getFileExtension(filename).toLowerCase();
    if (extension == 'pdf') {
        return 'pdf';
    } 
    return 'office';
    // https://stackoverflow.com/questions/39630273/online-doc-viewer
    // https://blog.poychang.net/apps/online-docs-viewer/office.html
    switch (extension) {
        case 'docx':
        case 'docm':
        case 'dotm':
        case 'dotx':
        case 'doc':
        case 'xlsx':
        case 'xlsb':
        case 'xls':
        case 'xlsm':
        case 'pptx':
        case 'ppsx':
        case 'ppt':
        case 'pps':
        case 'pptm':
        case 'potm':
        case 'ppam':
        case 'potx':
        case 'ppsm':
            return 'office'
    }
    return 'google'
}

function isImage(contentType) {
    return contentType.toLowerCase().startsWith('image/');
}

function Loading() {
    return <div title='Loading' style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F9F9F9'
    }}><span className="spinner-border spinner-border-xxl" style={{
        width: 50,
        height: 50
    }}></span>
    </div>
}

function RenderImage({ url, onLoad }) {
    return <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F9F9F9'
    }}>
        <img src={url} style={{ maxHeight: '90%', maxWidth: '90%', pointerEvents: 'none' }}
            onLoad={onLoad} onError={onLoad} />
    </div>
}

/*
export type DocumentPreviewProps = {
    storageFile: IStorageFile
    uploaderUser: IUser
    onHide: () => void
}

type ShowDocumentPreviewCallback = (storageFile: IStorageFile, uploaderUser: IUser) => void
*/
let messageListener;//: ShowDocumentPreviewCallback | null = null;

export function showDocumentPreview(storageFile, uploaderUser) {
    if (messageListener) {
        messageListener(storageFile, uploaderUser);
    }
}

export function DocumentPreviewContainer() {
    const [showPreview, setShowPreview] = React.useState(false);
    const [storageFile, setStorageFile] = React.useState(null);
    const [uploaderUser, setUploaderUser] = React.useState(null);

    React.useEffect(() => {
        messageListener = (storageFile, uploaderUser) => {
            setShowPreview(true)
            setStorageFile(storageFile);
            setUploaderUser(uploaderUser);
        };
    }, [])
    return <>{showPreview && storageFile && uploaderUser && <DocumentPreview onHide={() => setShowPreview(false)} storageFile={storageFile} uploaderUser={uploaderUser} />}</>
}

export function DocumentPreview({ storageFile, uploaderUser, onHide }) {
    const renderImage = isImage(storageFile.contentType);
    const [show, setShow] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [fileRemoteUrl, setFileRemoteUrl] = React.useState(null);
    const onIframeLoaded = () => {
        setLoading(false)
    };
    const onImageLoad = () => {
        setLoading(false)
    }

    const onDownloadBtnClick = () => {
        FileStorage.download(storageFile.id);
    }

    const onHideFunc = () => {
        setShow(false)
        onHide()
    }

    React.useEffect(() => {
        //setFileRemoteUrl("https://www.adobe.com/support/products/enterprise/knowledgecenter/media/c4611_sample_explain.pdf");
        if (!renderImage) {
            FileStorage.getSASUrl(storageFile.id).then(url => {
                setFileRemoteUrl(url);
            })
        } else {
            setFileRemoteUrl(FileStorage.getDownloadUrl(storageFile.id));
        }
    }, []);

    return <Modal isOpen={show} className="modal-file-preview" size='lg' toggle={onHideFunc} keyboard>
        <ModalHeader toggle={onHideFunc}>
            <><b>File preview:</b> <span style={{ fontWeight: 300 }}>{storageFile.fileName}</span></>
        </ModalHeader>
        <ModalBody style={{ padding: 0, position: 'relative' }}>
            {fileRemoteUrl && renderImage && <RenderImage onLoad={onImageLoad} url={fileRemoteUrl} />}
            {fileRemoteUrl && !renderImage && getDefaultViewer(storageFile.fileName) == 'pdf' && <PdfViewer url={fileRemoteUrl} loaded={onIframeLoaded} />}
            {fileRemoteUrl && !renderImage && getDefaultViewer(storageFile.fileName) != 'pdf' && <DocumentViewer
                url={fileRemoteUrl}
                viewerUrl={'url'}
                viewer={getDefaultViewer(storageFile.fileName)}
                style={{ width: '100%', height: '100%' }}
                loaded={onIframeLoaded}
            />}
            {loading && <Loading />}
            <div className="card card-custom card-flush border" style={{
                position: 'absolute',
                zIndex: 1,
                top: 0,
                right: 11,
                width: 250,
                borderBottomLeftRadius: 5,
                borderBottomRightRadius: 5,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                marginTop: -1,
                boxShadow: '0px 35px 35px 0px rgba(56, 71, 109, 0.075)'
            }}>
                {/* <div className="card-header">
                    <h4 className="card-title fs-4" style={{ wordBreak: 'break-all' }}>DD Form 1sdsadadasdadfsfsdfsddsfsdfsd23.pdf</h4>
                </div> */}
                <div className="card-body px-3">
                    {/* 
                    <div className="separator separator-dashed my-2"></div> */}

                    <div>
                        <div >
                            <div className="font-weight-bold mt-7">Uploaded by</div>
                            <div className="mt-1">
                                {uploaderUser.fullName}
                            </div>
                            <hr />

                            <div className="font-weight-bold mt-2">Upload date</div>
                            <div className="mt-1">
                                {storageFile.createdTime.toDateString()}
                            </div>
                            <hr />

                            <div className="font-weight-bold mt-2">File size</div>
                            <div className="mt-1">
                                {formatBytes(storageFile.fileSize)}
                            </div>
                            <hr />

                            <div className="font-weight-bold mt-2">Version</div>
                            <div className="mt-1">
                                {storageFile.version}
                            </div>

                        </div>
                    </div>

                </div>
                <div className="card-footer px-8">
                    <a onClick={onDownloadBtnClick} className="btn btn-primary w-100"><i className="uil-down-arrow"></i> Save file</a>
                </div>
            </div>
        </ModalBody>
    </Modal >
}